import config from '../../config';
import API from '../api';

const { baseUrl } = config.coreApi;

// Lists immutable configurations, including archived snapshots.
const getStoreAttributionConfigs = async bpid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${encodeURIComponent(bpid)}/store-attribution-configs`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

// Links a target site to a new immutable campaign snapshot.
const createStoreAttributionConfig = async (bpid, configuration) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${encodeURIComponent(bpid)}/store-attribution-configs`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'POST',
    body: JSON.stringify(configuration)
  }).then(res => API.generateResponse(res));
};

// Archives a configuration without deleting earlier attribution eligibility.
const archiveStoreAttributionConfig = async (bpid, cfgid) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${encodeURIComponent(bpid)}/store-attribution-configs/${encodeURIComponent(cfgid)}/archive`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'POST'
  }).then(res => API.generateResponse(res));
};

// Lists target sites scoped to the portal.
const getTargetSites = async bpid => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${encodeURIComponent(bpid)}/target-sites`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'GET'
  }).then(res => API.generateResponse(res));
};

// Creates a target site. Omit campaignId and attributionWindowDays together to link it later.
const createTargetSite = async (bpid, request) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${encodeURIComponent(bpid)}/target-sites`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'POST',
    body: JSON.stringify(request)
  }).then(res => API.generateResponse(res));
};

// Atomically creates target sites from a request containing parent and requests.
const batchCreateTargetSites = async (bpid, request) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${encodeURIComponent(bpid)}/target-sites/batch`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'POST',
    body: JSON.stringify(request)
  }).then(res => API.generateResponse(res));
};

// Updates target site metadata using displayName, description, parent and siteId; no update mask.
const updateTargetSiteMetadata = async (bpid, sid, metadata) => {
  await API.refreshTokenWhenNeeded();

  const url = `${baseUrl}/brandportals/${encodeURIComponent(bpid)}/target-sites/${encodeURIComponent(sid)}`;

  return fetch(url, {
    headers: { ...API.headers, 'X-Request-Id': crypto.randomUUID() },
    method: 'PATCH',
    body: JSON.stringify(metadata)
  }).then(res => API.generateResponse(res));
};

export {
  getStoreAttributionConfigs,
  createStoreAttributionConfig,
  archiveStoreAttributionConfig,
  getTargetSites,
  createTargetSite,
  batchCreateTargetSites,
  updateTargetSiteMetadata
};
